/**
 * 시그니처 3: 신뢰도 테두리 (DESIGN §8.6).
 *
 * 커버리지가 낮을수록 테두리가 흐려진다 — **숫자를 못 믿을수록 시각적으로도
 * 덜 단단해 보여야 한다.** 실측 커버리지가 0.46 이므로 대부분의 위젯이
 * 파선으로 그려지는 것이 정상이다.
 */

export function trustClass(coverage: number): 'trust-high' | 'trust-mid' | 'trust-low' {
  if (coverage >= 0.8) return 'trust-high'
  if (coverage >= 0.5) return 'trust-mid'
  return 'trust-low'
}
